import { createPublicTypedEventsListPage } from "../typedEvents/PublicTypedEventsListPage";

// The shared implementation, typed 'camp'. Change behavior in
// typedEvents/PublicTypedEventsListPage.tsx, once, for every type.
export default createPublicTypedEventsListPage("camp");
